import React, { useState } from "react";
import "./Section.css";

/**
 * A floating, rounded, collapsible section card used in the right-hand column
 * (Environments / Skills / Files). Header shows a title, an optional count
 * badge, and an optional action element (e.g. a "+ New" button); clicking the
 * header toggles the body.
 */
export default function Section({
  title,
  count = null,
  warn = false,
  defaultOpen = false,
  headerAction = null,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={`ca-section ${open ? "open" : "collapsed"}`}>
      <div className="ca-section-head">
        <button
          type="button"
          className="ca-section-toggle"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
        >
          <svg className="ca-section-chevron" width="12" height="12" viewBox="0 0 14 14" aria-hidden="true">
            <path d="M3.5 5.5 7 9l3.5-3.5" stroke="currentColor" strokeWidth="1.4"
                  fill="none" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span className="ca-section-title">{title}</span>
          {count != null && count !== 0 && (
            <span className="ca-section-count">{count}</span>
          )}
          {warn && (
            <span className="ca-section-warn" title="A connector needs re-authentication" aria-label="needs attention">!</span>
          )}
        </button>
        {headerAction && open && (
          <div className="ca-section-action">{headerAction}</div>
        )}
      </div>
      {open && <div className="ca-section-body">{children}</div>}
    </section>
  );
}
